const LOGIN_MODES = {
  store: { badge: 'Outlet counter', sub: 'Open the counter — billing, cash box and day close',
    before: 'Open the counter. ', emphasis: 'Close the day.', after: '', color: 'text-lime-400',
    description: "Bills, payment modes, the cash box and the credit register — every entry signed with the cashier's own 6-digit PIN, and a day close that has to balance before the shutters come down." },
  staff: { badge: 'Staff portal', sub: 'Your roster, your pay and your deliveries',
    before: 'Your work, ', emphasis: 'in your pocket', after: '.', color: 'text-sky-400',
    description: "Your roster, your PIN, your pay and the home deliveries handed to you. Nothing else, and nobody else's." },
  office: { badge: 'Group command centre', sub: "Head office — the whole group's money, live",
    before: 'Know where ', emphasis: 'every rupee', after: ' stands.', color: 'text-emerald-400',
    description: 'Counter sales, cash boxes, bank balances and approvals from every company — each figure set against the days before it, with the records behind it one tap away.' },
};

export const loginCopy = ({ isStore, isStaff, otp, method }) => {
  let mode = 'office';
  if (isStore) mode = 'store';
  else if (isStaff) mode = 'staff';
  const copy = { ...LOGIN_MODES[mode], heading: 'Sign in' };
  if (!otp) return copy;
  copy.heading = isStore ? 'Confirm this counter' : 'Verify this device';
  const descriptions = {
    totp: 'Open your authenticator app and enter the 6-digit code it shows.',
    recovery: 'Enter one of the recovery codes you saved when you set up the authenticator app.',
    email: `We emailed a 6-digit code to ${otp.emailHint}. It expires in 10 minutes.`,
  };
  copy.sub = descriptions[method] || descriptions.email;
  return copy;
};